import { flex } from "styled-system/patterns";

import { NetworkDownTooltip, useIsNetworkDown } from "@/contexts/health";
import { useAuthState } from "@/hooks/use-auth-state";

import { AccountButtons } from "./account-buttons";
import { AccountDropdown } from "./account-dropdown";
import { DesktopSkeletonControls, MobileSkeletonControls } from "./skeleton-controls";

export const DesktopAccountControls = () => {
  const isNetworkDown = useIsNetworkDown();
  const { state, subaccountAddress, accountAddress } = useAuthState();

  if (!subaccountAddress) {
    return <DesktopSkeletonControls />;
  }

  return (
    <NetworkDownTooltip isNetworkDown={isNetworkDown}>
      <div className={flex({ align: "center", gap: "8" })}>
        <div className={flex({ align: "center", gap: "24" })}>
          {state === "WALLET_CONNECTED" && <AccountButtons accountAddress={accountAddress} />}
          <AccountDropdown subaccountAddress={subaccountAddress} />
        </div>
      </div>
    </NetworkDownTooltip>
  );
};

export const MobileAccountControls = () => {
  const isNetworkDown = useIsNetworkDown();
  const { state, subaccountAddress, accountAddress } = useAuthState();

  if (!subaccountAddress) {
    return <MobileSkeletonControls />;
  }

  return (
    <NetworkDownTooltip isNetworkDown={isNetworkDown}>
      <div className={flex({ flex: "1", align: "center", justify: "space-between", gap: "8" })}>
        <AccountDropdown subaccountAddress={subaccountAddress} />
        {state === "WALLET_CONNECTED" && <AccountButtons accountAddress={accountAddress} />}
      </div>
    </NetworkDownTooltip>
  );
};
